// extracted by mini-css-extract-plugin
module.exports = {"c1xgw4jd":"c1xgw4jd","bounce-c1xgw4jd":"bounce-c1xgw4jd"};